import { addAtomDebugLabel } from '@ecomm/utils/addAtomDebugLabel'
import { Map as ImmutableMap } from 'immutable'
import { atom } from 'jotai'

import type { NinetailedFeatureFlagSchema } from './useNinetailedFeatureFlag/schema'

/**
 * Exported only for hydration purposes only in `WrapRootElement`.
 */
export const ninetailedFeatureFlagsAtom = atom<
  ImmutableMap<string, NinetailedFeatureFlagSchema>
>(ImmutableMap<string, NinetailedFeatureFlagSchema>())
addAtomDebugLabel(ninetailedFeatureFlagsAtom, 'ninetailedFeatureFlags')
